import store from '@/store'

export function handleResponse (response) {
  if (!response || !response.data || !response.data.status) {
    return '未知错误'
  } else {
    return handle(response.data.status)
  }
}

export function handle (code) {
  const error = store.state.errorCode.find(e => e.code === code)
  if (error) {
    return error.message
  } else {
    return '未知错误'
  }
}
